import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EventResponse} from "../../../model/response/event/event-response.model";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ErrorMessageEnum} from "../../../enums/error-message.enum";
import {ReportService} from "../../../../service/api/report.service";
import {ApiResponse} from "../../../model/response/ApiResponse";
import {MessageToastService} from "../../../../service/message-toast.service";

@Component({
    selector: 'app-report-modal',
    templateUrl: './report-modal.component.html',
    standalone: false
})
export class ReportModalComponent implements OnInit {

  @Input('event') event: EventResponse
  @Input('display') displayModal: boolean
  @Output('onCancelModal') onCancelModalEmitter = new EventEmitter()

  form: FormGroup
  formDescriptionFieldErro = null

  constructor(
    private reportService: ReportService,
    private messageToast: MessageToastService) {
  }

  ngOnInit(): void {
    this.initForm()
  }

  initForm() {
    this.form = new FormGroup<any>({
      'description': new FormControl(null, Validators.required)
    });
  }

  onSubmit() {
    if (this.form.invalid) {
      this.validateFieldErros()
    } else {
      this.apiReportEvent()
    }

  }

  validateFieldErros() {
    this.formDescriptionFieldErro = null

    if (this.form.get("description")?.hasError("required")) {
      this.formDescriptionFieldErro = ErrorMessageEnum.requiredField
    }

  }

  apiReportEvent() {
    this.reportService.create({eventId: this.event.id, message: this.form.value.description}).subscribe({
      next: (response) => {
        this.messageToast.success(response.message)
        this.form.reset()
        this.onCancelModalEmitter.emit()
      },
      error: (response: ApiResponse<any>) => this.messageToast.error(response?.message)
    })
  }

}
